import { toast } from 'sonner';

export const fileName = (path: string) => path.split('/').at(-1);

export async function copyFile(path: string, text: string) {
  try {
    await navigator.clipboard.writeText(text);
    toast.success(`Copied ${fileName(path)}`);
  } catch {
    toast.error(
      `Could not copy ${fileName(path)}. Select the text and copy it instead.`
    );
  }
}
